var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEncaminhar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0546 17.3709V15.0547H6.83243C5.61647 15.0547 4.55974 14.6687 3.66224 13.8967C2.76475 13.1247 2.316 12.1596 2.316 11.0015C2.316 9.84349 2.76475 8.87844 3.66224 8.1064C4.55974 7.33437 5.61647 6.94835 6.83243 6.94835H14.1282L11.1172 9.9593L12.7385 11.5806L18.5288 5.79029L12.7385 0L11.1172 1.62128L14.1282 4.63223H6.83243C4.96023 4.63223 3.35343 5.24021 2.01201 6.45617C0.670594 7.67213 -0.000114202 9.18726 -0.000114202 11.0015C-0.000114202 12.8158 0.670594 14.331 2.01201 15.5469C3.35343 16.7629 4.96023 17.3709 6.83243 17.3709H15.0546Z",
    fill: "#325374"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncaminhar);
export default __webpack_public_path__ + "static/media/encaminhar.06cb0728fccf2b7181fab13be3f05de8.svg";
export { ForwardRef as ReactComponent };